import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getLeadBackground } from '@/actions/leads/getLeadBackground';
import { ApiResponse } from '@/types/response.type';
import { LeadBackground } from '@/types/zee-candidate.type';

export interface UseGetLeadBackgroundReturn {
  result: ApiResponse<LeadBackground> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetLeadBackground = (
  leadId: string
): UseGetLeadBackgroundReturn => {
  const query: UseQueryResult<ApiResponse<LeadBackground> | undefined, Error> =
    useQuery({
      queryKey: ['user-background', leadId],
      queryFn: () => getLeadBackground(leadId),
      enabled: !!leadId,
    });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
